// react
import React from 'react';
import { Provider } from 'react-redux';

// relative
import { store } from './store';

export const ReduxProvider = ({ children }: { children: React.ReactNode }) => (
  <Provider store={store}>{children}</Provider>
);
